export default "/cliente/cliente/img/home-banner-2024.png"